/**
 * URL constants for external links and resources
 */

export const EXTERNAL_URLS = {
  HELP_CENTER: 'https://www.landvoice.com/help',
  CONTACT_US: 'https://www.landvoice.com/contact-us',
} as const;

/**
 * Contact information constants
 */
export const CONTACT_INFO = {
  PHONE_NUMBER: '888-678-0905',
  PHONE_NUMBER_FORMATTED: '(888) 678-0905',
  PHONE_NUMBER_LINK: 'tel:8886780905',
} as const;

